import { render } from "./mvt-article.vue?vue&type=template&id=38664044"
import script from "./mvt-article.js?vue&type=script&lang=js"
export * from "./mvt-article.js?vue&type=script&lang=js"

import "./mvt-article.vue?vue&type=style&index=0&id=38664044&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__